import { observer } from 'mobx-react-lite'
import type { JobScopeChangesDisplayViewModel } from '@/features/jobs/details/JobScopeChangesViewModel'
import { Button } from '@/components/Button'
import { ActionCard } from '@/features/jobs/details/components/ActionCard'
import { ScrolledAction } from '@/features/jobs/details/components/PageHeader'

interface PendingJobScopeChangeSectionContainerProps {
  vm: JobScopeChangesDisplayViewModel
}

export const PendingJobScopeChangeSectionContainer = observer(
  function PendingJobScopeChangeSectionContainer({
    vm,
  }: PendingJobScopeChangeSectionContainerProps) {
    const pendingScopeChange = vm.pendingJobScopeChange

    if (!pendingScopeChange) {
      return null
    }

    const isTax = vm.job.match({
      tax: () => true,
      default: () => false,
    })

    return (
      <>
        <ActionCard
          kicker={
            isTax
              ? 'Unable to complete your return'
              : 'Unable to complete your request'
          }
          title="Additional work needed"
        >
          <Button
            label="Review updates"
            variant="destructive"
            onPress={() => vm.show(pendingScopeChange)}
            testId="pending-scope-change-review-button"
          />
        </ActionCard>
      </>
    )
  },
)

interface PendingJobScopeChangeScrolledActionContainerProps {
  vm: JobScopeChangesDisplayViewModel
}

/**
 * Scrolled action for the header.
 */
export const PendingJobScopeChangeScrolledActionContainer = observer(
  function PendingJobScopeChangeScrolledActionContainer({
    vm,
  }: PendingJobScopeChangeScrolledActionContainerProps) {
    const pendingScopeChange = vm.pendingJobScopeChange

    if (!pendingScopeChange) {
      return null
    }

    return (
      <ScrolledAction
        label="Review updates"
        onPress={() => vm.modalJobScopeChangeVm.show(pendingScopeChange)}
        testId="pending-scope-change-review-scrolled-button"
      />
    )
  },
)
